<template>
  <div>
		<WebHearder></WebHearder>
		<router-view></router-view>
		<footers></footers>
<!-- 		<div v-if="$fff">
			<div class="modal-cover" style="height: 4359px;"></div>
		</div> -->
  </div>
</template>

<script>
import WebHearder from './components/header.vue'
import footers from './components/footer.vue'
import * as homeapi from './api/index.js'
export default {
  name: 'App',
	components:{
		WebHearder,
		footers
	},
	async created() {
		this.checkToken()
    this.getContactUs()
    await this.getSettings()
    this.$isResolve()
	},
	methods:{
		checkToken(){
			let token = localStorage.getItem('token')
			homeapi.check_token({
				token
			}).then(res => {
				if(!res){
					localStorage.clear();
				}
			})
		},
    getContactUs() {
    	let token = localStorage.getItem('token')
    	homeapi.connection({
    			token: token,
    		})
    		.then(result => {
    			localStorage.setItem("datum",JSON.stringify(result.data))
    		})
    },
    getSettings(){
      return new Promise((relove,reject) => {
        homeapi.systemsettings()
        .then(result => {
          console.log(result)
          localStorage.setItem('settingPc',JSON.stringify(result))
          this.$namePc = result.name
          relove(true)
        })
      })
    }
	}
}
</script>

<style>
@import './static/iconfont.css';
@import './static/index.css';
@import './static/common.css';

@import './static/animatel.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.modal-cover{
	top: 0;
	    left: 0;
	    right: 0;
	    bottom: 0;
	    width: 100%;
	    height: 100%;
	    position: fixed;
	    z-index: 999;
	    background-color: #000;
	    filter: alpha(opacity=60);
	    opacity: .6;
}
</style>



// WEBPACK FOOTER //
// src/App.vue